import React, { useMemo } from 'react';
import { SummarySectionV2 } from '@css-xp/base';
import { EntitlementDetails, RelationshipPathType } from '@css-xp/graphtypes/src/generated-types-new';
import { SandboxParent } from './sandbox-parent';

export const SandboxParentSection = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  const sandboxParentEntitlementId = useMemo(() => {
    const sandboxDependenceEntitlement = entitlement?.relatesFromEntitlements?.find(
      (relationShipObj) => relationShipObj?.relationshipType === RelationshipPathType.SANDBOX_DEPENDENCE
    );
    return sandboxDependenceEntitlement?.entitlementId;
  }, [entitlement]);

  // Should display only for sandbox entitlements
  if (!entitlement?.isSandbox || entitlement?.isApp || !sandboxParentEntitlementId) {
    return null;
  }

  return (
    <SummarySectionV2.SummaryGridCalloutItem testId="summary-uuid">
      <div className="billing-plan">
        <label>Parent product</label>
        <div className="entitlement-details-column" style={{ whiteSpace: 'nowrap' }}>
          <SandboxParent sandboxParentId={sandboxParentEntitlementId} entitlement={entitlement} />
        </div>
      </div>
    </SummarySectionV2.SummaryGridCalloutItem>
  );
};
